import { useTheme } from "react-jss";

const useThemedStyle = (useStyle, props) => {
  const theme = useTheme();
  return useStyle({ ...props, theme });
};

export default useThemedStyle;
